export default "__VITE_ASSET__BGKmvlkC__"